import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { EnvironmentService } from "../environment.service";
import { ExternalSalesmanCardDetails } from "../../interfaces/external-salesman-card/external-salesman-card-details.interface";

@Injectable()
export class ExternalSalesmanCardService {
  private readonly http: HttpClient;

  constructor(handler: HttpBackend, private environmentService: EnvironmentService) {
    this.http = new HttpClient(handler);
  }

  public show(identifier: string, accessCode: string): Observable<ExternalSalesmanCardDetails> {
    const params = new HttpParams().set("access_code", accessCode);
    const baseUrl = this.environmentService.get("api.url") || "";
    return this.http
      .get<ExternalSalesmanCardDetails>(`${baseUrl}/api/public/external_salesman_cards/${identifier}`, { params })
      .pipe(tap((_) => console.log("ExternalSalesmanCardService.show: Ok.")));
  }
}
